import AcademicLicence from "./AcademicLicence";

export default AcademicLicence;
